import type { VoiceSetting } from './api';

export type VoiceDraft = { voiceId: string | null; speed: number; engine: 'standard' | 'self_hosted' | 'ema'; ownVoice: string | null; backupVoice?: string | null };

/**
 * The voice part of a spec save. The API MERGES the voice object, so the source (engine) and the speed are always
 * sent — left out, an earlier choice stays (live 2026-09-30: switching back to the standard voice did not stick).
 * Nothing is sent only when the agent never had a voice setting and none was picked.
 */
export const voicePatch = (v: VoiceDraft, initial: VoiceSetting | null): { voice?: VoiceSetting } =>
  v.voiceId || v.engine !== 'standard' || initial || v.backupVoice
    ? {
        voice: {
          ...(v.voiceId ? { voiceId: v.voiceId } : {}), speed: v.speed, engine: v.engine,
          ...(v.engine === 'self_hosted' && v.ownVoice ? { ownVoice: v.ownVoice } : {}),
          // BRAIN/35: the backup voice is kept whatever the engine (it speaks when the engine cannot).
          ...(v.backupVoice ? { backupVoice: v.backupVoice } : {}),
        },
      }
    : {};
